import type { RouteRecordRaw } from 'vue-router'
import ErrorLayout from '@/layouts/ErrorLayout.vue'
import NotFound from '@/views/NotFound.vue'
import accessRoutes from './access'
import authRoutes from './auth'
import dashboardRoutes from './dashboard'
import growthRoutes from './growth'
import leadersRoutes from './leaders'
import offersRoutes from './offers'
import ordersRoutes from './orders'
import releasesRoutes from './releases'
import requisitionsRoutes from './requisitions'
import servicesRoutes from './services'
import settingsRoutes from './settings'
import transactionsRoutes from './transactions'
import usersRoutes from './users'

export const routes: RouteRecordRaw[] = [
  ...authRoutes,
  ...dashboardRoutes,
  ...requisitionsRoutes,
  ...offersRoutes,
  ...transactionsRoutes,
  ...usersRoutes,
  ...leadersRoutes,
  ...growthRoutes,
  ...accessRoutes,
  ...settingsRoutes,
  ...releasesRoutes,
  ...ordersRoutes,
  ...servicesRoutes,
  // 404 Not Found route (must be last)
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      layout: ErrorLayout, // optional: if you use layouts
      title: 'صفحه یافت نشد',
    },
  },
]
